import { useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Dialog } from "components/Dialog/Dialog";
import {
    GetLegacyNextAssetsQuery,
    GetLegacyNextAssetsQueryVariables,
    InsightsProperty,
} from "graphql-types/graphql";
import { useLegacyNextStore } from "legacyNext/store";
import { SearchTerms } from "legacyNext/types";

import { Header, Search } from "./components";
import { S } from "./home.styles";
import { SEARCH_QUERY } from "./queries";

export const Home = () => {
    const { t } = useTranslation();

    const { setAssetList } = useLegacyNextStore();

    const [noAssetDialogOpen, setNoAssetDialogOpen] = useState(false);

    const [fetchData, { loading }] = useLazyQuery<
        GetLegacyNextAssetsQuery,
        GetLegacyNextAssetsQueryVariables
    >(SEARCH_QUERY);

    const onSearchTermChange = async (searchTerms: SearchTerms) => {
        const { data } = await fetchData({
            variables: {
                searchFilters: searchTerms,
            },
        });
        setAssetList((data?.getLegacyNextAssets as InsightsProperty[]) || []);
        setNoAssetDialogOpen(!data?.getLegacyNextAssets.length);
    };

    return (
        <S.Page>
            {noAssetDialogOpen && (
                <Dialog
                    title={t("legacyNext.map", "map")}
                    content={t("legacyNext.noAssets", "no assets")}
                />
            )}
            <S.Content>
                <Header />
                <S.Search>
                    <Search
                        loading={loading}
                        onSearchTermChange={onSearchTermChange}
                    />
                </S.Search>
                <S.SearchView>
                    <Outlet />
                </S.SearchView>
            </S.Content>
        </S.Page>
    );
};
